'use client';

import type {MyList} from 'server/apiHandlers/getMyListsHandler';
import MapView from './MapView';
import useMap from './useMap';

type Props = {
  myLists: MyList[];
  places: Partial<Place>[];
  session: IronSession | null;
};

const SimpleMap = ({myLists, places, session}: Props) => {
  const {mapContainer, map} = useMap({variant: 'places', places});

  return (
    <MapView
      map={map}
      mapContainer={mapContainer}
      myLists={myLists}
      places={places}
      className="w-full h-full"
      session={session}
    />
  );
};

export default SimpleMap;
